module.exports = __webpack_public_path__ + "static/media/57.c05c3b38.jpg";